import React from 'react';
import PropTypes from 'prop-types';
import DisplayPrice from '../_utils/display-price';

const UpsellAmount = ({
  price,
  freeShippingThreshold,
  assetUrl,
  className,
}) => {
  const amountNeeded = freeShippingThreshold - price;

  if (!price) {
    return null;
  }

  const message =
    amountNeeded <= 0 ? (
      <>
        You&apos;re getting{' '}
        <span className="font-weight-bold">free shipping</span> on your Home
        Delivery items
      </>
    ) : (
      <>
        Spend <DisplayPrice price={amountNeeded} className="font-weight-bold" />{' '}
        more on Home Delivery to get{' '}
        <span className="font-weight-bold">free shipping</span>
      </>
    );

  return (
    <div
      className={`align-items-center mb-2 mt-2 ${className}`}
      data-test-id="upsell-prompt">
      {assetUrl && (
        <img
          alt=""
          src={assetUrl}
          style={{ height: '48px' }}
          data-test-id="upsell-image"
        />
      )}
      <span
        className={`mb-0 ${assetUrl ? 'ml-2' : ''}`}
        data-test-id="upsell-amount">
        {message}
      </span>
    </div>
  );
};

UpsellAmount.propTypes = {
  price: PropTypes.number,
  freeShippingThreshold: PropTypes.number,
  assetUrl: PropTypes.string,
  className: PropTypes.string,
};

UpsellAmount.defaultProps = {
  className: 'd-flex',
};

export default UpsellAmount;
